import { useEffect, useState } from 'react';
import './Header.css';

import { useNavigate } from "react-router-dom";
import utils from '../../Functions/utils';
import { isFullMonth } from '../../Functions/getFormattedDate';


function HeaderComp(props) {


  const [brandData, setBrandData] = useState({});
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await fetchBrandData();
    };
    fetchData();
  }, []);

    const fetchBrandData = async () => {
        const localKey = 'brandData';
        try {
          const cached = localStorage.getItem(localKey);
          if (cached) {
            setBrandData(JSON.parse(cached));
            // console.log(cached)
          } else {
            const resp = await utils.requestData('GetBrandData', {});
            // console.log(resp[0])
            // if (resp[0].code !== 90) throw new Error(resp[0].msg);
            setBrandData(resp[0]);
            localStorage.setItem(localKey, JSON.stringify(resp[0]));
          }
        } catch (err) {
          console.error('Error fetching DailyBooks:', err);
          setError(err.message);
        }
      };

  const handleLogout = async () => {
    try {
      localStorage.clear();
      navigate("/");
      window.location.reload(); // מרענן את ה-App
    } catch (error) {
      console.error("שגיאה בהתנתקות", error);
    }
  };


  const handleProfile = () => {
    navigate('/profile');
  };
  
  const handleHomePage = () => {
    
    navigate('/');
  };

  const handleCharidy = () => {
    navigate('/charidy');
  };

  
  const handleBO = () => {
    navigate('/bo');
  };

  return (  
    <div className="header">
      <div className="logo">{brandData.name}</div>
      <div className="user-info">

        {props.userData?.fName && props.userData?.lName && (
          <span className="hello">{props.userData.fName} {props.userData.lName}</span>
        )}

        <div className="menu-wrapper">
          <button onClick={() => props.setMenuHeaderOpen(prev => !prev)}>
            ☰ תפריט
          </button>


          {props.menuHeaderOpen && (
            <div className="dropdown-menu">

              {localStorage.getItem("auth-token") == "7AA8660F-254D-436A-95AC-8527A531BAEB" && (
                <button onClick={handleBO}>
                  <span role="img" aria-label="bo">⚙️</span> ניהול
                </button>
              )} 

              <button onClick={handleHomePage}>
                <span role="img" aria-label="home">🏠</span> דף הבית
              </button>

              {localStorage.getItem("auth-token") == "7AA8660F-254D-436A-95AC-8527A531BAEB" && (
                <button onClick={handleCharidy}>
                  <span role="img" aria-label="charity">❤️</span> הצדקה שלי
                </button>
              )}
              
              <button onClick={handleProfile}>
                <span role="img" aria-label="profile">👤</span> אזור אישי
              </button>
              <button onClick={handleLogout}>
                <span role="img" aria-label="logout">🚪</span> התנתק
              </button>
            </div>
          )}

        </div>

      </div>
    </div>

  );
}

export default HeaderComp;
